import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = state => state[NAME].byId
export const getAllOverlayIds = state => state[NAME].allKeys
const selected = state => state[NAME].selected

export const getOverlayById = createSelector(
  [byIdSelector, selected],
  (byId, selected) => id => {
    const overlay = byId[id] || null
    if (overlay !== null) {
      overlay.selected = selected[id]
    }
    return overlay
  }
)

export const getOverlays = createSelector(
  [getOverlayById, getAllOverlayIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getSelectedOverlayIds = createSelector(
  [getAllOverlayIds, selected],
  (allKeys, selected) => allKeys.filter(id => selected[id])
)

export const getSelectedOverlays = createSelector(
  [getSelectedOverlayIds, getOverlayById],
  (selectedIds, byId) => selectedIds.map(byId)
)
